module.exports = __webpack_public_path__ + "static/media/event-05.a03a2266.jpg";